<template>
  <div v-if="formatModules()">
    <div v-if="!videoshow && djsState">
      <div class="userGuide" :style="`top:${navH+11}px`" >
        <img src="@/assets/fdts.png"
               class="userGuideTri"
               alt="">
        <div class="userGuideCont" >
          <span  v-if="mType === 1 || mType === '1'" class="userGuideText">视频已收起，可点此查看</span>
          <span v-else class="userGuideText">音频已收起，可点此查看</span>
        </div>
        <div class="userGuideSep" ></div>
      </div>
    </div>
    <div :class="[pzy50 ? 'videoview' : 'videoview2']" v-if="videoshow"></div>
  </div>
</template>

<style lang="less" scoped>
.videoview2 {
  align-items: center;
  flex-direction: row;
  width: 100%;
  height: 420px;
}

.videoview {
  align-items: center;
  flex-direction: row;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 20px;
  height: 420px;
  border-radius: 12px;
}
.userGuide{
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    right: 80px;
    top: 188px;
    z-index: 9999999;
  }
  .userGuideTri{
    position: absolute;
    opacity: 0.8;
    width: 42px;
    height: 21px;
    right: 40px;
    top: -20px;
  }
  .userGuideSep{
    height: 25px;
  }
  .userGuideCont{
    z-index: 99;
    opacity: 0.8;
    background: #000;
    border-radius: 12px;
    height: 76px;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .userGuideText{
    padding-left: 30px;
    padding-right: 30px;
    font-size: 24px;
    color: #ffffff;
    line-height: 36px;
  }
</style>

<script>

import {
  setVideoData,
  setVideoShowState,
  getIs50Sys,
} from '@/utils/nativeBridge';
import { mapGetters } from 'vuex';
import StoreManger from '@/utils/FundHQJHManger';
import NativeMsg from '@/base/NativeMsg';

export default {
  components: {},
  data() {
    return {
      videoshow: false,
      nosetVideo: false,
      djsState: false,
      mType: 0,
      navH: 0,
      pzy50: false,
    };
  },
  computed: {
    ...mapGetters({
      zbInfo: 'currentZBDate',
    }),
  },
  created() {
    if (getIs50Sys()) {
      this.pzy50 = true;
    }
    NativeMsg.reg('onPageShow', () => {
    });
    NativeMsg.reg('hiddenvideo', (res) => {
      console.log('get hiddenvideo');
      this.nosetVideo = true;
      if (res) {
        if (res.hidden === '1') {
          this.showHiddenTip();
          const { fundCode } = this.$store.state.native.fund;
          this.setCache(`video${fundCode}`, '1');
          this.setshowViedost(false);
        } else {
          const { fundCode } = this.$store.state.native.fund;
          this.setCache(`video${fundCode}`, '0');
          this.setshowViedost(true);
        }
      }
    });
    NativeMsg.reg('mainRefresh', () => {
      this.nosetVideo = false;
    });
    this.navH = StoreManger.getNAVSTATEHEIGHT();
  },
  methods: {
    showHiddenTip() {
      if (this.mType !== 0) {
        const { fundCode } = this.$store.state.native.fund;
        if ((this.getCache(`videoshowtip${fundCode}`) === '1')) {
          this.djsState = false;
        } else {
          this.djsState = true;
          setTimeout(this.setcloseTip, 3000);
        }
      }
    },
    setshowViedost(state) {
      this.videoshow = state;
      if (this.videoshow) {
        setVideoShowState({ show: 'true' });
      } else {
        setVideoShowState({ show: 'false' });
      }
    },
    setcloseTip() {
      this.djsState = false;
      const { fundCode } = this.$store.state.native.fund;
      this.setCache(`videoshowtip${fundCode}`, '1');
    },
    setCache(key, value) {
      window.localStorage.setItem(key, value);
    },
    getCache(key) {
      return window.localStorage.getItem(key);
    },
    formatModules() {
      return false;
    },
    configureVideo(item) {
      console.log('configureVideo');
      if (this.nosetVideo) {
        return;
      }
      if (item.video) {
        this.nosetVideo = true;
      } else {
        this.nosetVideo = true;
        this.setshowViedost(false);
      }
      const { fundCode } = this.$store.state.native.fund;
      const w = document.documentElement.clientWidth;
      const topY = this.navH + 10;
      // #endif
      if (getIs50Sys()) {
        setVideoData({
          top: topY,
          left: 15,
          width: w - 30,
          height: 210,
          fcode: fundCode,
          cornerRadius: 12,
          clientWidth: w,
          video: item,
        });
      } else {
        setVideoData({
          top: 0,
          left: 0,
          width: w,
          height: 210,
          fcode: fundCode,
          cornerRadius: 0,
          clientWidth: w,
          video: item,
        }).then((res) => {
          if (!getIs50Sys()) {
            if (res) {
              if (res.hidden === 1) {
              // 收起
                this.videoshow = false;
              }
              if (res.hidden === 0) {
                // 展开
                this.videoshow = true;
              }
            }
          }
        }).catch(() => {
        });
      }
      if (!(this.getCache(`video${fundCode}`) === '1')) {
        this.nosetVideo = true;
        if (item.state === '1') {
          this.setshowViedost(false);
        } else {
          this.showHiddenTip();
          this.setshowViedost(false);
        }
      } else {
        this.nosetVideo = true;
        this.showHiddenTip();
        this.setshowViedost(false);
      }
    },
  },
};
</script>
